const Provinces: string[] = [
  "Western Province",
  "Central Province",
  "Southern Province",
  "Uva Province",
  "Sabaragamuwa Province",
  "North Western Province",
  "North Central Province",
  "Nothern Province",
  "Eastern Province",
];

export default Provinces;
